import { render, staticRenderFns } from "./DashboardV3.vue?vue&type=template&id=936bc274&scoped=true&"
import script from "./DashboardV3.vue?vue&type=script&lang=js&"
export * from "./DashboardV3.vue?vue&type=script&lang=js&"
import style0 from "./DashboardV3.vue?vue&type=style&index=0&id=936bc274&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "936bc274",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VTextarea})
